import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface InfoLineProps {
  className?: string;
  title: string;
}

const InfoLine = ({ children, className, title }: InfoLineProps & PropsWithChildren) => (
  <div
    className={classNames(
      'flex gap-10',
      'not-print:max-desktop:flex-col not-print:max-desktop:gap-0 not-print:max-desktop:mt-2',
      className,
    )}
  >
    <div className={classNames('grow basis-0 text-right font-medium text-accent', 'not-print:max-desktop:text-center')}>{title}</div>
    <div className={classNames('grow basis-0', 'not-print:max-desktop:text-center')}>{children}</div>
  </div>
);

export default InfoLine;
